import React from 'react';

import { i18n } from 'app/i18n';
import { ProductsSummary } from 'app/page/orders/model/products-summary';
import { OrderSummaryMapper } from 'app/page/orders/mapper/order-summary-mapper';
import { OrderSummary, ProductGroup } from 'app/page/orders/model/order-summary';
import { ActiveOrder } from 'app/page/orders/model/active-order';
import { SummaryGroup, EquipmentSummaryGroup } from 'app/components/domain/summary-group';
import { OrderUtils } from 'app/page/orders/utils/order-utils';
import { Card } from 'app/components/domain/card/card';
import { TotalPrices } from 'app/components/domain/total-prices';

interface OwnProps {
    activeOrder: ActiveOrder;
}

type Props = OwnProps;

class SelectedProducts extends React.Component<Props> {
    public render(): React.ReactNode {
        const { activeOrder } = this.props;

        const orderSummary: OrderSummary = OrderSummaryMapper.mapOrderSummary(OrderUtils.getShoppingCart(activeOrder));

        return (
            <Card>
                {this.renderSelectedProducts()}
                <TotalPrices orderSummary={orderSummary} />
            </Card>
        );
    }

    private readonly renderSelectedProducts = (): React.ReactNode => {
        const { activeOrder } = this.props;

        const summary: ProductsSummary = OrderSummaryMapper.mapProductsSummary(OrderUtils.getShoppingCart(activeOrder));

        return (
            <>
                {this.renderBroadband(summary)}
                {this.renderTv(summary)}
                {this.renderEquipment(summary)}
            </>
        );
    };

    private readonly renderBroadband = (summary: ProductsSummary): React.ReactNode => {
        if (!summary.broadbandPlan) {
            return null;
        }

        const broadbandGroups: ProductGroup[] = [
            {
                lines: summary.broadband,
            },
        ];

        return (
            <SummaryGroup
                title={i18n.summary.productDetails.group.broadband}
                summaryPlanLine={summary.broadbandPlan}
                summaryGroups={broadbandGroups}
            />
        );
    };

    private readonly renderTv = (summary: ProductsSummary): React.ReactNode => {
        if (!summary.tvPlan) {
            return null;
        }

        const tvGroups: ProductGroup[] = [
            {
                groupTitle: i18n.summary.productDetails.group.tvChannelPackages,
                lines: summary.tvChannelPackages,
            },
            {
                groupTitle: i18n.summary.productDetails.group.tvStreaming,
                lines: summary.tvStreaming,
            },
            {
                groupTitle: i18n.summary.productDetails.group.tvChannels,
                lines: summary.tvChannels,
            },
            {
                lines: summary.tv,
            },
        ];

        return (
            <SummaryGroup
                title={i18n.summary.productDetails.group.tv}
                summaryPlanLine={summary.tvPlan}
                summaryGroups={tvGroups}
            />
        );
    };

    private readonly renderEquipment = (summary: ProductsSummary): React.ReactNode => {
        if (!summary.equipment || summary.equipment.length === 0) {
            return null;
        }

        return (
            <EquipmentSummaryGroup
                title={i18n.summary.productDetails.group.equipment.title}
                summaryLines={summary.equipment}
            />
        );
    };
}

export { SelectedProducts };
